import { render, staticRenderFns } from "./InspectionClassificationDialog.vue?vue&type=template&id=5bfba553&scoped=true&"
import script from "./InspectionClassificationDialog.vue?vue&type=script&lang=js&"
export * from "./InspectionClassificationDialog.vue?vue&type=script&lang=js&"
import style0 from "./InspectionClassificationDialog.vue?vue&type=style&index=0&id=5bfba553&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfba553",
  null
  
)

export default component.exports